import { useEffect, useState } from "react";
import { Menu, Button, TextField, MenuItem, Box, Stack } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

function MultiSearchFilter({
  options,
  value,
  setValue,
  width,
  disabled,
  filterName,
  appliedFilters,
  setAppliedFilters,
}) {
  const [selectedOptions, setSelectedOptions] = useState(
    value === "All" ? [] : value.split(",")
  );
  const [searchText, setSearchText] = useState("");
  const [openMenu, setOpenMenu] = useState(null);

  const searchTextLowerCase = searchText.toLocaleLowerCase();

  useEffect(() => {
    if (value === "All") setSelectedOptions([]);
  }, [value]);

  return (
    <Box sx={{ width: width || "100%" }}>
      <Button
        size="small"
        variant="outlined"
        sx={{
          py: 0,
          height: 28,
          width: "100%",
          display: "flex",
          textAlign: "left",
          alignItems: "center",
          justifyContent: "space-between",
          borderColor: "#bbb",
          color: "#444",
          fontWeight: 400,
          textWrap: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        disabled={disabled}
        onClick={(e) => setOpenMenu(openMenu ? null : e.currentTarget)}
      >
        {value.split(",").length > 1 ? "Multiple" : value}
        <ArrowDropDownIcon fontSize="small" />
      </Button>
      <Menu
        disableAutoFocusItem
        open={Boolean(openMenu)}
        anchorEl={openMenu}
        onClose={() => setOpenMenu(null)}
      >
        <Stack px={0.8}>
          <TextField
            fullWidth
            size="small"
            autoComplete="off"
            placeholder="Search..."
            onKeyDown={(e) => e.stopPropagation()}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </Stack>
        {searchText === "" && (
          <MenuItem
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
            onClick={() => {
              let flag = true;

              if (appliedFilters.includes(filterName)) {
                let index = appliedFilters.indexOf(filterName);
                if (index > -1)
                  setAppliedFilters(appliedFilters.slice(0, index));
              }

              if (value === "All" && selectedOptions.lenght === 0) {
                setSelectedOptions(options);
              } else if (
                value === "All" &&
                selectedOptions.length === options.length
              ) {
                setSelectedOptions([]);
                flag = false;
              } else {
                setValue("All");
                setSelectedOptions(options);
              }

              if (flag) {
                if (!appliedFilters.includes(filterName)) {
                  setAppliedFilters([...appliedFilters, filterName]);
                }else{
                  let index = appliedFilters.indexOf(filterName);
                  if (index > -1)
                    setAppliedFilters(appliedFilters.slice(0, index));
                }
              } else {
                let index = appliedFilters.indexOf(filterName);
                if (index > -1)
                  setAppliedFilters(appliedFilters.slice(0, index));
              }
            }}
          >
            {selectedOptions.length === options.length ? (
              <CheckBoxIcon color="primary" fontSize="small" />
            ) : (
              <CheckBoxOutlineBlankIcon color="inherit" fontSize="small" />
            )}
            Select All
          </MenuItem>
        )}
        {options
          .filter(
            (item) =>
              searchText === "" ||
              item.toLocaleLowerCase().includes(searchTextLowerCase)
          )
          .map((item, index) => (
            <MenuItem
              key={index}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
              onClick={() => {
                let values = [];

                if (selectedOptions.includes(item)) {
                  values = selectedOptions.filter((i) => i !== item);
                } else {
                  values = [...selectedOptions, item];
                }

                if (values.length > 0) {
                  if (!appliedFilters.includes(filterName)) {
                    setAppliedFilters([...appliedFilters, filterName]);
                  }
                } else {
                  let index = appliedFilters.indexOf(filterName);
                  if (index > -1) {
                    console.log(
                      "Applied filters: ",
                      appliedFilters.slice(0, index)
                    );
                    setAppliedFilters(appliedFilters.slice(0, index));
                  }
                }

                setSelectedOptions(values);
                setValue(
                  values.length === 0 || values.lenght === options.length
                    ? "All"
                    : values.join(",")
                );
              }}
            >
              {selectedOptions.includes(item) ? (
                <CheckBoxIcon color="primary" fontSize="small" />
              ) : (
                <CheckBoxOutlineBlankIcon color="inherit" fontSize="small" />
              )}
              {item.replaceAll("_", " ")}
            </MenuItem>
          ))}
      </Menu>
    </Box>
  );
}

export default MultiSearchFilter;
